import {createContext, useContext, useReducer, useEffect} from "react"
import themeReducer from "./themeReducer";

export const ThemeContext = createContext();

const stored = (() => { try { return JSON.parse(localStorage.getItem('themeSettings')); } catch { return null; } })();
const initialThemeState = stored || { theme: 'light-theme' };

export const ThemeProvider = ({children}) => {
    const [themeState, dispatchTheme] = useReducer(themeReducer, initialThemeState);

    const themeHandler = (buttonClassName) => {
        dispatchTheme({type: buttonClassName})
    }

    // save theme settings to local storage
    useEffect(() => {
        localStorage.setItem('themeSettings', JSON.stringify(themeState))
    }, [themeState])

    return <ThemeContext.Provider value={{themeState, themeHandler}}>{children}</ThemeContext.Provider>
}

// custom hook to use our theme context wherever we want in our project
export const useThemeContext = () => {
    return useContext(ThemeContext);
}